export default __webpack_public_path__ + "static/media/dinner.435fb94a.svg";